import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: 70,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    boxShadow: '0px -2px 10px rgba(0,0,0,0.05)',
    zIndex: 1100,
    [theme.breakpoints.up('md')]: {
      display: 'none' // Esconde no Desktop
    }
  },
  navItem: {
    display: 'flex',
    flexDirection: 'column', // Empilha ícone e texto para um visual mobile clássico
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    // Cor padrão (Inativo)
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.secondary
        : theme.palette.grey[500],
    flex: 1,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out', // Transição suave para a cor ativa

    // ESTADO ATIVO: Quando a classe .active for aplicada via JS
    '&.active': {
      color: theme.palette.blue_300.main, // Cor de destaque (Azul)
      '& $icon': {
        transform: 'scale(1.1)' // Um leve "pop" no ícone ativo
      }
    }
  },
  icon: {
    width: 24,
    height: 24
  },
  label: {
    fontSize: '1rem',
    fontWeight: 500
  },
  // O Botão Central Verde
  centerButtonContainer: {
    position: 'relative',
    top: -25, // Faz o botão "subir" para fora da barra
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 1200
  },
  fabButton: {
    backgroundColor: '#67C23A', // Verde da imagem
    color: '#fff',
    width: 60,
    height: 60,
    boxShadow: '0px 4px 10px rgba(103, 194, 58, 0.4)',
    border: '4px solid #fff', // Borda branca que cria o efeito de separação
    '&:hover': {
      backgroundColor: '#5daf34'
    }
  },
  badge: {
    position: 'absolute',
    top: -5,
    right: -12,
    backgroundColor: theme.palette.red_100.main, // Vermelho para notificações
    color: 'white',
    borderRadius: '50%',
    padding: '2px 6px',
    fontSize: '0.65rem',
    fontWeight: 'bold'
  }
}))
